<template>
 <div id="taskutilizationchart"></div>  
</template>
<script>

import ApexCharts from 'apexcharts'
export default {
  props: {
    projectTaskUtilization : null,
  },
  mounted() {
    let labels =  ['No data'];
    let utilization = [];

    if(this.projectTaskUtilization.userUtilization.utilization.length > 0)
    {
      labels = this.projectTaskUtilization.userUtilization.utilization.map(u => u.name);
      utilization = this.projectTaskUtilization.userUtilization.utilization.map(u => u.hours);
    }

    let totalWorkingHours = labels.length == 1 ? utilization[0] : this.projectTaskUtilization.totalWorkingHours;

    var options = {
      labels: labels,
      series: utilization,
        chart: {
          height: 305,
          type: 'donut',
      },
      dataLabels: {
        enabled: true,
      },

      colors: ['#5499C7', '#CD6155', '#58D68D', '#F5B041', '#D4EFDF', '#F2D7D5'],

      legend: {
        show: false,
      },
      tooltip: {
          y: {
            formatter: function (y) {
              if (typeof y !== "undefined") {
                return y.toFixed(0) + " h";
              }
              return y;
            }
          }
        }
    };

   var chart = new ApexCharts(document.querySelector("#taskutilizationchart"), options);
   chart.render();

  },
};
</script>